import React, { useState } from "react";
import { X, AlertTriangle } from "lucide-react";

const DeleteMeeting = ({ closeDeleteEvent, onEventDeleted, selectedEvent }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState("");

  const confirmDelete = async () => {
    try {
      setIsDeleting(true);
      setError("");

      console.log("=== DeleteMeeting - confirmDelete ===");
      console.log("selectedEvent reçu:", selectedEvent);
      console.log("selectedEvent.id:", selectedEvent?.id);

      if (!selectedEvent || !selectedEvent.id) {
        setError("Erreur: Aucune réunion sélectionnée");
        console.error("selectedEvent manquant ou sans ID:", selectedEvent);
        setIsDeleting(false);
        return;
      }

      // Appeler la fonction de suppression avec l'ID
      if (onEventDeleted) {
        console.log("📞 Appel de onEventDeleted avec ID:", selectedEvent.id);
        const result = await onEventDeleted(selectedEvent.id);
        console.log("📞 Résultat de onEventDeleted:", result);
        
        // Si la suppression a réussi, on ferme le popup
        if (result !== false) {
          closeDeleteEvent(false);
        }
      } else {
        setError("Erreur: Fonction de suppression non disponible");
      }

    } catch (err) {
      console.error("Delete error:", err);
      setError(err.message || "Une erreur s'est produite lors de la suppression");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl transform transition-all duration-300 ease-in-out">
        <div className="p-6 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">Supprimer la réunion</h2>
            <button
              type="button"
              className="p-2 rounded-full hover:bg-gray-100 transition-all duration-200"
              onClick={() => closeDeleteEvent(false)}
            >
              <X className="h-5 w-5 text-gray-500" />
            </button>
          </div>
        </div>

        <div className="p-6">
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 rounded-md mb-6 flex items-start">
              <AlertTriangle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5 text-red-500" />
              <p>{error}</p>
            </div>
          )}

          <div className="flex items-center mb-4 bg-amber-50 p-4 rounded-lg">
            <AlertTriangle className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0" />
            <div>
              <p className="text-gray-800 font-medium">
                Vous êtes sur le point de supprimer la réunion :
              </p>
              <p className="font-bold text-lg mt-1">{selectedEvent?.titre || "Cette réunion"}</p>
              <p className="text-sm text-gray-600 mt-1">
                {selectedEvent?.date_heure && new Date(selectedEvent.date_heure).toLocaleString('fr-FR')}
              </p>
            </div>
          </div>

          <p className="text-gray-600 mb-6">
            Cette action est <span className="font-bold">irréversible</span>. Toutes les données
            associées à cette réunion seront définitivement supprimées.
          </p>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors duration-200 font-medium"
              onClick={() => closeDeleteEvent(false)}
              disabled={isDeleting}
            >
              Annuler
            </button>
            <button
              type="button"
              className={`px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-200 font-medium shadow-sm ${isDeleting ? "opacity-70 cursor-not-allowed" : ""
                }`}
              onClick={confirmDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <span className="flex items-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Suppression...
                </span>
              ) : (
                "Supprimer définitivement"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteMeeting;